import { handleAction } from 'redux-actions';
import { Record } from 'immutable';
import { isEqual } from 'lodash';
import { switchDetail } from '../actions/faq';

export const ReducerRecord = Record({
  options: global.__PRELOADED_STATE__.faq,
  selectedOption: null,
});

export default handleAction(switchDetail, (state, { meta, payload }) => (
  state.set(
    'selectedOption',
    meta.selfClosing && isEqual(state.selectedOption, payload) ? null : payload,
  )
), new ReducerRecord());
